module.exports = __webpack_public_path__ + "static/media/nn-live-bkg.ca65d2a3.png";